<template>
    <div class="lo extend">
        <transition name="fade">
            <mdLoading
                v-if="loadingState > 0"
            ></mdLoading>
        </transition>
        <gPopUp
            v-for="popUp in popUps"
            :key="popUp.sn"
            :type="popUp.type"
            :sn="popUp.sn"
            :content="popUp.content"

            @sendEvent="receiveEvent"
        ></gPopUp>
        <div
            v-if="notifications.length > 0"
            class="g notification"
        >
            <gNotification
                v-for="notification in notifications"
                :key="notification.sn"
                :type="notification.type"
                :sn="notification.sn"
                :content="notification.content"

                @sendEvent="receiveEvent"
            ></gNotification>
        </div>
        <gToolTip
            v-for="toolTip in toolTips"
            :key="'toolTip'+ toolTip.sn"
            :type="toolTip.type"
            :sn="toolTip.sn"
            :event="toolTip.event"
            :content="toolTip.content"
            :pointerEvents="toolTip.pointerEvents"

            @sendEvent="receiveEvent"
        ></gToolTip>
        <mdCalendarPanel v-if="datePicker.show"></mdCalendarPanel>
        <mdTalkList></mdTalkList>
        <mdUserTalk
            v-if="islogin"
        ></mdUserTalk>
        <mdTalkBox></mdTalkBox>
    </div>
</template>

<script>
    import gPopUp from '@/components/gPopUp'
    import gNotification from '@/components/gNotification'
    import gToolTip from '@/components/gToolTip'
    import mdLoading from '@/components/mdLoading'
    import mdTalkList from '@/components/mdTalkList'
    import mdUserTalk from '@/components/mdUserTalk'
    import mdTalkBox from '@/components/mdTalkBox'
    import mdCalendarPanel from '@/components/mdCalendarPanel'
    
    import { mapState } from 'vuex'

    export default {
        components: {
            gPopUp,
            gNotification,
            gToolTip,
            mdLoading,
            mdTalkList,
            mdUserTalk,
            mdTalkBox,
            mdCalendarPanel
        },
        computed: {
            ...mapState([
                'user',
                'popUps',
                'notifications',
                'toolTips',
                'loadingState',
                'datePicker',
            ]),
            islogin: function(){
                return this.user.sn;
            },
        }
    }
</script>

<style scoped lang="scss">

    .fade-enter-active, .fade-leave-active {
        transition: 250ms ease;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-to {
        opacity: 1;
    }

    .fade-leave {
        opacity: 1;
    }

    .fade-leave-to {
        opacity: 0;
    }

    .lo.extend {
        
    }
    
    .g.notification {
        display: flex;
        position: fixed;
        z-index: 1201;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        pointer-events: none;
        
        // left: 10px;
        // max-width: 300px;

        @include media('phone') {
            left: 10px;
            max-width: none;
        }
    }

    .lo.extend {

    }
</style>
